<template>
    <v-container fluid>
        <DynamicToolbar
            title="Manual Readings"
            :loading="loading"
            color="blue darken-4"
            icon="mdi-map-clock"
            theme="dark"
        ></DynamicToolbar>
        <manual-readings></manual-readings>
    </v-container>
</template>

<script>
import DynamicToolbar from '../../components/Global/Utils/DynamicToolbar.vue';
import ManualReadings from '@/components/Dispatch/ManualReadings.vue';

export default {
    name: 'ManualView',
    components: {
        DynamicToolbar,
        ManualReadings
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = 'Manual Readings';
            }
        }
    }
};
</script>
